import Section from "../Section"
import styles from "./ReviewSlider.module.scss"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Keyboard, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import ReviewSliderSlide from "./Slide"
import { ChevronLeft, ChevronRight } from "react-feather"
import { useCallback, useEffect, useState } from "react"

const ReviewSlider = ({ data }) => {
  const [swiper, setSwiper] = useState(null)

  useEffect(() => {
    // HACK: You can't replace the breakpoints property directly on the swiper instance.
    if (swiper && swiper.params) {
      swiper.params.breakpoints = {
        0: {
          slidesPerView: 1.3,
          spaceBetween: 16,
          centeredSlides: true,
        },
        640: { slidesPerView: 2, spaceBetween: 16, centeredSlides: true },
        768: { slidesPerView: 2.3, spaceBetween: 16, centeredSlides: true },
        1024: { slidesPerView: 2, spaceBetween: 40, centeredSlides: false },
        1200: { slidesPerView: 3, spaceBetween: 40, centeredSlides: false },
      }
      swiper.currentBreakpoint = false
      swiper.update()
    }
  }, [swiper])

  const handleResize = useCallback(() => {
    swiper && swiper.update()
  }, [swiper])

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [handleResize, swiper])

  return (
    <Section>
      <div className={styles.ReviewSlider}>
        <div className={styles.contentWrapper}>
          {data?.section_headline && (
            <div
              className={styles.headline}
              dangerouslySetInnerHTML={{ __html: data?.section_headline }}
            />
          )}

          <div className={styles.sliderWrapper}>
            <Swiper
              onSwiper={(swipe) => {
                setSwiper(swipe)
              }}
              loop={true}
              keyboard={{
                enabled: true,
                pageUpDown: false,
              }}
              navigation={{
                nextEl: ".review-slider-swiper-button-next",
                prevEl: ".review-slider-swiper-button-prev",
              }}
              modules={[Navigation, Keyboard, Autoplay]}
              autoplay={
                data?.autoplay
                  ? {
                      delay: 5000,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                      waitForTransition: true,
                    }
                  : false
              }
              slidesPerView="auto"
              spaceBetween={40}
              breakpoints={{}}
            >
              {data?.review_items?.map((item, index) => (
                <SwiperSlide key={index}>
                  <ReviewSliderSlide data={item} />
                </SwiperSlide>
              ))}
            </Swiper>

            <div className={styles.swiperNav}>
              <span className="review-slider-swiper-button-prev btn btn-primary !p-3 mr-4">
                <ChevronLeft />
              </span>
              <span className="review-slider-swiper-button-next btn btn-primary !p-3">
                <ChevronRight />
              </span>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default ReviewSlider
